"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.Properties = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "noBackdrop", type: "boolean", defaultValue: "false", description: "If true, hide backdrop." }),
    React.createElement(common_1.Property, { name: "open", type: "boolean", description: "If true, show modal." }),
    React.createElement(common_1.Property, { name: "onClose", type: "function", defaultValue: "() => { return; }", description: "Called when click in backdrop." }))); };
exports.Properties.displayName = 'Properties';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ModalPage/Properties.tsx
// module id = 701
// module chunks = 0